import { Caption, useAppDisplayModeContext } from '@archipro-design/aria';
import { useStyles } from '@archipro-design/aria';
import { useGetStartedAction } from '~/modules/design-board/hook';
import * as S from '../board-list/NoBoardState.style';
import { CallToActionImageGrid } from '~/modules/design-board/component/shared/CallToActionImageGrid';

const NoPinState = () => {
    const { css } = useStyles();
    const { mobile } = useAppDisplayModeContext();
    const { isLoggedIn, getStartedButton } = useGetStartedAction('/');

    const extraText = isLoggedIn
        ? ''
        : 'Sign up to create your own design boards, upload your own content, and collaborate with others.';

    return (
        <div className={css(S.NoPinState)}>
            <div className={css(S.NoPinStateContent)}>
                <Caption>
                    Browse ArchiPro to start saving products, projects,
                    professionals, and articles that inspire you.
                    <div>{extraText}</div>
                </Caption>
            </div>

            {getStartedButton}

            {!mobile && (
                <div className={css(S.CallToActionContainer)}>
                    <CallToActionImageGrid />
                </div>
            )}
        </div>
    );
};

export default NoPinState;
